import {makeAutoObservable} from "mobx";
import {ViewController} from "data/types/structure";
import {injectable, inject} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import type {IModalsStore} from "data/stores/modals/modals.store";
import {ModalType} from "data/enums";

export interface IModalTomorrowGameController extends ViewController {
	i18n: ILocalizationStore;
	get isOpen(): boolean;
	close: () => void;
}

@injectable()
export class ModalTomorrowGameController implements IModalTomorrowGameController {
	constructor(
		@inject(Bindings.LocalizationStore) public readonly i18n: ILocalizationStore,
		@inject(Bindings.ModalsStore) private readonly _modalsStore: IModalsStore
	) {
		makeAutoObservable(this);
	}

	get isOpen(): boolean {
		return this._modalsStore.modal === ModalType.TOMORROW_GAME;
	}

	close = () => {
		this._modalsStore.hideModal();
	};
}
